<div class="login-container">
  <!-- Theme Switcher Toggle -->
  <div class="login-theme-toggle-wrap" *ngIf="false">
    <theme-switcher></theme-switcher>
  </div>

  <!-- Left Panel (Illustration & Branding for Desktop/Tablets) -->
  <div class="left-panel">
    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
      <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
      <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
      <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
    </div>

    <div class="left-panel-text">
      {{ 'LOGIN.LEFT_TEXT' | translate }}
    </div>

    <div class="left-panel-image-wrap">
      <img src="assets/dashboard icons/AshaPic-removebg.png" alt="Asha" class="left-hero-img" />
    </div>
  </div>

  <!-- Right Panel (Login Form) -->
  <div class="right-container">
    <div class="login-card-wrapper">
      <!-- Mobile logos strip shown when left panel is hidden -->
      <div class="mobile-logos-bar">
        <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
        <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
        <img class="mobile-center-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
        <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
        <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
      </div>

      <div class="login-card">
        <div class="login-header-icon-wrap">
          <img class="login-header-icon" src="assets/icons/headericon_pink.png" alt="Asha" />
        </div>

        <h2 class="login-title">{{ 'LOGIN.TITLE' | translate }}</h2>

        <p class="login-subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>

        <form class="login-form" (submit)="onSubmit($event)">

          <dx-form #loginForm [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top"
            class="custom-login-form" [showColonAfterLabel]="false">

            <dxi-form-item dataField="email" id="email" editorType="dxTextBox" [editorOptions]="{
                stylingMode: 'outlined',
                placeholder: ('LOGIN.USERNAME_PLACEHOLDER' | translate),
                buttons: [{
                  name: 'userIcon',
                  location: 'after',
                  options: { icon: 'custom-user-icon' }
                }],
                onEnterKey: onUsernameEnterKey
              }">
              <dxo-label [text]="'LOGIN.USERNAME' | translate"></dxo-label>
            </dxi-form-item>

            <dxi-form-item dataField="password" id="password" editorType="dxTextBox" [editorOptions]="{
                stylingMode: 'outlined',
                placeholder: ('LOGIN.PASSWORD_PLACEHOLDER' | translate),
                mode: passwordMode,
                buttons: [{
                  name: 'togglePassword',
                  location: 'after',
                  options: {
                    icon: passwordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                    onClick: togglePasswordVisibility
                  }
                }],
                onEnterKey: onPasswordEnterKey
              }">
              <dxo-label [text]="'LOGIN.PASSWORD' | translate"></dxo-label>
            </dxi-form-item>
          </dx-form>

          <div class="forgot-password-text">
            <a (click)="NavigateForgotPassword()"> {{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a>
          </div>

          <div class="login-action-wrap">
            <dx-button [text]="'LOGIN.BUTTON' | translate" type="default" stylingMode="contained" class="login-button"
              (click)="onSubmit($event)" [disabled]="loading"></dx-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>